(function initQuantityPricePopoverPositioning() {
  function setupPopoverPositioning(popoverElement) {
    if (popoverElement.dataset.popoverPositioned === "yes") return;
    var triggerButton = document.querySelector(
      '[popovertarget="' + popoverElement.id + '"]',
    );
    if (!triggerButton || !popoverElement.matches("[popover]")) return;
    popoverElement.dataset.popoverPositioned = "yes";
    popoverElement.addEventListener("toggle", function onPopoverToggle(event) {
      if (event.newState === "closed") {
        popoverElement.classList.remove("quantity-price-popover--visible");
        document.body.classList.remove("quantity-price-popover-open");
        return;
      }
      if (event.newState !== "open") return;
      var viewportWidth = window.innerWidth;
      var isMobile = viewportWidth <= 749;
      if (!isMobile) {
        var triggerRect = triggerButton.getBoundingClientRect();
        var paddingPx = 8;
        var popoverWidth = popoverElement.offsetWidth || 280;
        var popoverHeight = popoverElement.offsetHeight || 200;
        var viewportHeight = window.innerHeight;
        var left = triggerRect.left;
        var top = triggerRect.bottom + paddingPx;
        if (left + popoverWidth > viewportWidth - paddingPx)
          left = viewportWidth - popoverWidth - paddingPx;
        if (left < paddingPx) left = paddingPx;
        if (top + popoverHeight > viewportHeight - paddingPx)
          top = triggerRect.top - popoverHeight - paddingPx;
        if (top < paddingPx) top = paddingPx;
        popoverElement.style.left = left + "px";
        popoverElement.style.top = top + "px";
        popoverElement.style.transform = "";
      } else {
        document.body.classList.add("quantity-price-popover-open");
        popoverElement.style.left = "";
        popoverElement.style.top = "";
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          popoverElement.classList.add("quantity-price-popover--visible");
        });
      });
    });
  }

  function initAllQuantityPricePopovers() {
    document
      .querySelectorAll("[data-quantity-price-popover]")
      .forEach(setupPopoverPositioning);
  }

  function observeDOMForNewPopovers() {
    var observer = new MutationObserver(function onMutation(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches("[data-quantity-price-popover]")) {
            setupPopoverPositioning(node);
            continue;
          }
          if (
            node.querySelector &&
            node.querySelector("[data-quantity-price-popover]")
          ) {
            initAllQuantityPricePopovers();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllQuantityPricePopovers();
      observeDOMForNewPopovers();
    });
  } else {
    initAllQuantityPricePopovers();
    observeDOMForNewPopovers();
  }
  document.addEventListener(
    "shopify:section:load",
    initAllQuantityPricePopovers,
  );
  window.initQuantityPricePopovers = initAllQuantityPricePopovers;
})();

if (!window.__qtyTierToggleBound) {
  window.__qtyTierToggleBound = true;
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-tier-toggle]");
    if (!btn) return;
    var tooltip = btn.closest("quantity-price-tooltip");
    if (!tooltip) return;
    tooltip.classList.toggle("quantity-price-tooltip--expanded");
    btn.setAttribute(
      "aria-expanded",
      tooltip.classList.contains("quantity-price-tooltip--expanded"),
    );
  });
}

if (!customElements.get("quantity-price-tooltip")) {
  customElements.define(
    "quantity-price-tooltip",
    class QtyTierTooltip extends HTMLElement {
      constructor() {
        super();
        this.qty = parseInt(this.dataset.quantity || "1", 10);
      }

      connectedCallback() {
        this.highlightActiveTier(this.qty);
        var quantityInput = null;
        var cartItem = this.closest(
          "[data-cart-item], .cart-items-product, .cart-item-row",
        );
        if (cartItem) {
          quantityInput = cartItem.querySelector(
            '.quantity-input, input[name="updates[]"]',
          );
        }
        if (!quantityInput) {
          var wrapper = this.closest(".product-quantity-wrapper");
          if (wrapper) {
            quantityInput = wrapper.querySelector('input[name="quantity"]');
          }
        }
        if (quantityInput) {
          var self = this;
          function onQuantityChange() {
            var inputQty = parseInt(quantityInput.value || "1", 10) || 1;
            // Cart drawer input (updates[]) IS the total qty — don't add cart qty on top
            if (quantityInput.name === "updates[]") {
              self.qty = inputQty;
            } else {
              var cartQty =
                parseInt(
                  quantityInput.getAttribute("data-cart-quantity") || "0",
                  10,
                ) || 0;
              self.qty = cartQty + inputQty;
            }
            self.highlightActiveTier(self.qty);
          }
          quantityInput.addEventListener("change", onQuantityChange);
          quantityInput.addEventListener("input", onQuantityChange);
        }
      }

      highlightActiveTier(quantity) {
        var qty = parseInt(quantity, 10) || 1;
        var tierRows = this.querySelectorAll(
          ".quantity-price-tier-row[data-quantity]",
        );
        var activeRow = null;
        for (var i = 0; i < tierRows.length; i++) {
          tierRows[i].classList.remove("quantity-price-tier-row--active");
          if (qty >= parseInt(tierRows[i].dataset.quantity || "0", 10))
            activeRow = tierRows[i];
        }
        if (activeRow)
          activeRow.classList.add("quantity-price-tier-row--active");
      }
    },
  );
}
